'use client'

import { ErrorPanel } from '@/components/error/error-panel'
import { Button } from '@/components/ui/button'
import { ServerCrashIcon } from 'lucide-react'
import { useTranslations } from 'next-intl'

/**
 * What an error page shows (#878). Only the fixed texts: the error's own message can be a backend
 * detail. `retry` reloads the page from the server; `reset` would only draw the failed result again.
 */
export function ServerErrorPanel({ retry }: { retry: () => void }) {
  const t = useTranslations()
  return (
    <ErrorPanel icon={ServerCrashIcon} title={t('error_500_title')} description={t('error_500_description')}>
      <Button onClick={() => retry()}>{t('error_500_footer')}</Button>
    </ErrorPanel>
  )
}
